export default __webpack_public_path__ + "static/media/pantry1-afterG-1920w.63784f1c.webp";